import { Info } from "lucide-react";
import React, { ChangeEvent } from "react";

import { currencyFormatter } from "@intelligems/ig-graphs/data-formatters";
import {
  IgSwitch,
  IgTextField,
  IgTooltip,
  IgTypography,
} from "@intelligems/ig-theme";
import { FormControlLabel, Stack } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useConfiguration } from "@src/api/configurations/use-configuration";
import { IExperienceDashboardFilters } from "@src/store/types/dashboardFilters";

interface MinMaxRevenueFilterProps {
  minRevenue: number | null;
  maxRevenue: number | null;
  minKey: "minNetRevenue" | "minShippingRevenue";
  maxKey: "maxNetRevenue" | "maxShippingRevenue";
  minLabel: string;
  maxLabel: string;
  onNumberOrNullChange: (
    newValue: number | null,
    filterKey: keyof Pick<
      IExperienceDashboardFilters,
      | "minNetRevenue"
      | "maxNetRevenue"
      | "minShippingRevenue"
      | "maxShippingRevenue"
    >
  ) => void;
  excludeFreeOrders?: boolean;
  onExcludeFreeOrdersChange?: (excludeFreeOrders: boolean) => void;
}
export const MinMaxRevenueFilter = ({
  minRevenue,
  maxRevenue,
  onNumberOrNullChange,
  minKey,
  maxKey,
  minLabel,
  maxLabel,
  excludeFreeOrders,
  onExcludeFreeOrdersChange,
}: MinMaxRevenueFilterProps) => {
  const storeCurrencyConfig = useConfiguration<{
    code: string;
    locale: string;
  }>("shop_currency");

  return (
    <Stack direction={"column"} spacing={2}>
      <IgTextField
        type="number"
        placeholder={`Ex. ${currencyFormatter(10, false, storeCurrencyConfig!.value, false, false)}`}
        label={minLabel}
        value={minRevenue}
        onChange={(e) => {
          if (e.target.value === "") {
            onNumberOrNullChange(null, minKey);
          } else {
            onNumberOrNullChange(parseFloat(e.target.value), minKey);
          }
        }}
      />
      <IgTextField
        type="number"
        placeholder={`Ex. ${currencyFormatter(30, false, storeCurrencyConfig!.value, false, false)}`}
        label={maxLabel}
        value={maxRevenue}
        onChange={(e) => {
          if (e.target.value === "") {
            onNumberOrNullChange(null, maxKey);
          } else {
            onNumberOrNullChange(parseFloat(e.target.value), maxKey);
          }
        }}
      />
      {excludeFreeOrders !== undefined && onExcludeFreeOrdersChange && (
        <Grid container justifyContent={"space-between"} alignItems={"center"}>
          <Grid>
            <IgTypography mr={1}>Include free orders</IgTypography>
          </Grid>
          <Grid>
            <IgSwitch
              checked={!excludeFreeOrders}
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                onExcludeFreeOrdersChange(!e.target.checked)
              }
              size="small"
            />
          </Grid>
        </Grid>
      )}
    </Stack>
  );
};
